import { render, staticRenderFns } from "./CompleteMentorshipModal.vue?vue&type=template&id=1cb348a1&"
import script from "./CompleteMentorshipModal.vue?vue&type=script&lang=js&"
export * from "./CompleteMentorshipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports